'use strict';

/**
 * Faq block
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

(function ($) {
	let $faqBlock = $('.js-faq-block');

	$faqBlock.on('click', '.faq-block__header', function () {
		let $this = $(this).closest('.faq-block__item');
		let open = 'is-open';

		if (!$this.hasClass(open)) {
			$this.addClass(open).siblings().removeClass(open);
		} else {
			$this.removeClass(open);
		}
	});
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/_modules/faq-block.js